module.exports = __webpack_public_path__ + "static/media/javascript.61ed8b05.svg";